<div id="feedback-form-wrapper">
  <div id="floating-icon">
    <button
      type="button"
      class="btn btn-primary btn-sm rounded-0"
      (click)="openModal()"
    >
      <i class="fas fa-smile"></i> &nbsp;
      <strong>{{ "Employee satisfaction" | translate }}</strong>
    </button>
  </div>
  <div id="feedback-form-modal">
    <ng-template #feedbackModal>
      <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ "Employee satisfaction" | translate }}
              </h5>
              <button
                type="button"
                class="btn-close"
                (click)="closeModal()"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                  <label>{{
                    "Select category before giving the feedback" | translate
                  }}</label>
                  <ng-select
                    [items]="categories"
                    bindLabel="name"
                    formControlName="category"
                    placeholder="{{ 'Select satisfaction level' | translate }}"
                    class="mb-2"
                  >
                  </ng-select>
                  <div
                    *ngIf="
                      feedbackForm.get('category')?.invalid &&
                      feedbackForm.get('category')?.touched
                    "
                    class="text-danger"
                  >
                    {{ "Category is required" | translate }}
                  </div>
                </div>
                <div class="form-group">
                  <label>{{
                    "How likely are you satisfied with your current job/position?"
                      | translate
                  }}</label>
                  <div
                    class="rating-input-wrapper d-flex justify-content-between mt-2"
                  >
                    <label *ngFor="let rating of ratings">
                      <input
                        type="radio"
                        formControlName="rating"
                        [value]="rating"
                      />
                      <span class="border rounded px-3 py-2">{{ rating }}</span>
                    </label>
                  </div>
                  <div
                    *ngIf="
                      feedbackForm.get('rating')?.invalid &&
                      feedbackForm.get('rating')?.touched
                    "
                    class="text-danger"
                  >
                    {{ "Rating is required" | translate }}
                  </div>
                  <div
                    class="rating-labels d-flex justify-content-between mt-1"
                  >
                    <label>{{ "Very unlikely" | translate }}</label>
                    <label>{{ "Very likely" | translate }}</label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="input-two">{{
                    "Would you like to say something?" | translate
                  }}</label>
                  <textarea
                    class="form-control"
                    id="input-two"
                    rows="3"
                    formControlName="comments"
                  ></textarea>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="closeModal()"
                  >
                    {{ "Close" | translate }}
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="feedbackForm.invalid"
                  >
                    {{ "Submit" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
